/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreAssignSubtaskDto } from '../../models/core-assign-subtask-dto';
import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';

export interface ProjectSubtasksControllerAssignSubtask$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The subtask ID to assign.
 */
  id: string;
  
    /**
     * Assignment data (assignedTo, dates, hourly cost)
     */
    body: CoreAssignSubtaskDto
}

export function projectSubtasksControllerAssignSubtask(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerAssignSubtask$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerAssignSubtask.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>;
    })
  );
}

projectSubtasksControllerAssignSubtask.PATH = '/o2-core/project-subtasks/{tenant}/{id}/assign';
